import React, { useMemo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../Hooks";
import { RotateHorizontal } from "../../../Images/RotateHorizontal";
import { RotateVertical } from "../../../Images/RotateVertical";
import { FxIdDomainSettingsEGameOrientation } from "../../../Api/gen";

interface IGameOrientationProps {
	gameOrientation: FxIdDomainSettingsEGameOrientation;
}

const GameOrientation = ({ gameOrientation }: IGameOrientationProps) => {
	log.info("Render GameOrientation...");

	const { t } = useTranslation();
	const isMobile = useIsMobile();

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});

	useEffect(() => {
		const handleResize = () => {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const { width, height } = dimensions;

	const orientation = useMemo(() => {
		return width >= height
			? FxIdDomainSettingsEGameOrientation.Horizontal
			: FxIdDomainSettingsEGameOrientation.Vertical;
	}, [width, height]);

	const needRotate = useMemo(() => {
		return isMobile && gameOrientation !== orientation;
	}, [isMobile, gameOrientation, orientation]);

	if (!needRotate) return null;

	const isHorizontalOrientation = gameOrientation === FxIdDomainSettingsEGameOrientation.Horizontal;

	const text = isHorizontalOrientation
		? t("game_screen.game_orientation.text_horizontal")
		: t("game_screen.game_orientation.text_vertical");

	return (
		<div className={`game-orientation ${isHorizontalOrientation ? "" : " rotate"}`}>
			{isHorizontalOrientation ? <RotateHorizontal /> : <RotateVertical />}
			<h2>{t("game_screen.game_orientation.title")}</h2>
			<div>{text}</div>
		</div>
	);
};

export default GameOrientation;
